<template>
	<div class="pd">
		<div class="title-header">Записи к врачам</div>
		<div class="title-text">
			Пользователь {{ userStore.oms }}
		</div>
	</div>
	<div v-if="appointmentsLoaded">
		<Grid v-if="appointments.length > 0" :column-num="1" :gutter="8" :border="false" class="appointments-container">
			<AppointmentCard v-for="appointment in appointments" :appointment="appointment" :key="appointment.id" :onCancel="onCancel"/>
		</Grid>
		<Empty v-else description="Пока заявок нет">
			<Button round type="primary" :to="{name: 'new-appointment'}">Создать заявку</Button>
		</Empty>
	</div>
</template>

<script>
import { ref } from 'vue';
import { Grid, Empty, Button, showNotify } from 'vant';
import AppointmentCard from '@/components/common/AppointmentCard';
import { useUserStore } from '@/stores/user';
import Api from '@/api/Api';
import { AppointmentStatuses } from '@/models/appointment';


export default {
	components: {
		Grid, Empty, Button,
		AppointmentCard,
	},
	setup() {
		const userStore = useUserStore();
		const appointments = ref([]);
		const appointmentsLoaded = ref(false);
		return {
			userStore,
			appointments,
			appointmentsLoaded,
		};
	},
	mounted() {
		Api.getAppointmentsList(this.handleAppointmentsList);
		window.scrollTo(0, 0);
	},
	methods: {
		handleAppointmentsList(data) {
			this.appointments = data;
			this.appointmentsLoaded = true;
		},
		onCancel(appointmentId) {
			Api.cancelAppointment(appointmentId, this.handleCancelAppointment);
		},
		handleCancelAppointment(data) {
			if (data.status == 'deleted') {
				for (let appointment of this.appointments) {
					if (appointment.id === data.appointmentId) {
						appointment.status = AppointmentStatuses.CANCELLED;
					}
				}
				showNotify({
					message: 'Заявка удалена',
					color: '#ad0000',
					background: '#ffe1e1',
				});
			} else {
				showNotify({
					message: 'Ошибка',
					color: '#ad0000',
					background: '#ffe1e1',
				});
			}
		},
	}
}
</script>

<style scoped>
.appointments-container {
	padding-bottom: 8px;
}
</style>
